// The choices the card settings row offers. Kept in step with RouteCard's
// validations (PACE_RANGE_KMH, CLIMB_RANGE_MINUTES) and the apps' steppers.

/** Walking pace on the flat, km/h. */
export const PACE_OPTIONS = [2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6];

/** Minutes added per 100 m climbed — 10 is Naismith's own figure. */
export const CLIMB_OPTIONS = [0, 5, 6, 8, 10, 12, 15];

/**
 * The grids a card can be referenced in — PrintMaps::Crs keys. `null` is
 * "Default": the national grid of the country the hike is in.
 */
export const GRID_OPTIONS = [null, 'ie', 'gb', 'utm', 'nz', 'latlon', 'latlon_dms'] as const;
export type GridOption = typeof GRID_OPTIONS[number];

